/**
 * Created by Rumyantsev Daniil on 19.03.2018.
 */
import {Pipe, PipeTransform} from '@angular/core';
import {MeteringUnitConversionService} from '../_service/metering-unit-conversion.service';

/*
 * Возвращает строку, содержащую показания (с количеством чисел после запятой равных
 *  "fractionalPartLength" (по умолчанию = 3)) и ед. измерения показаний.
 * Если значения показаний не заполнены возывращает строку "Нет данных"
 * Если значения есть, но нет ед. измерения выводит только значения
 *
 * Usage:
 *   <meterValue> | metValStr : <consMeteringUnit> : <fractionalPartLength>
 *
 * Example:
 *    // meter.consumptionValue1 = 325
 *    // meter.consumptionValueMeteringUnit1 = 'кВт'
 *   {{ meter.consumptionValue1 | metValStr : meter.consumptionValueMeteringUnit1}}
 *   formats to: 325 кВт
 *    // meter.consumptionValue1 = 325
 *    // meter.consumptionValueMeteringUnit1 = '' || null
 *   {{ meter.consumptionValue1 | metValStr : meter.consumptionValueMeteringUnit1}}
 *   formats to: 325
 *    // meter.consumptionValue1 = null
 *    // meter.consumptionValueMeteringUnit1 = 'кВт'
 *   {{ meter.consumptionValue1 | metValStr : meter.consumptionValueMeteringUnit1}}
 *   formats to: Нет данных
 */
@Pipe({name: 'metValStr'})
export class MeterValueString implements PipeTransform {

  constructor(private meteringUnitConversionService: MeteringUnitConversionService){}

  readonly DEFAULT_FRACTIONAL_PART_LENGTH = 3;

  transform(meterValue: number, meteringUnit: string,
            fractionalPartLength: number = this.DEFAULT_FRACTIONAL_PART_LENGTH): string {

    if(meterValue == null) { return null; }

    const roundedMeterValue = parseFloat(meterValue.toFixed(fractionalPartLength));
    console.debug("Rounded value in meterValueStringPipe", roundedMeterValue);

    if(meteringUnit == null || meteringUnit == "") { return roundedMeterValue.toString(); }

    const convertedMeteringUnit = this.meteringUnitConversionService.convert(meteringUnit);

    return roundedMeterValue + ' ' + convertedMeteringUnit;
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/meter-value-string-pipe.ts